import { createFromEntries } from './object-poly';

export const fromEntries: ObjectConstructor['fromEntries'] = createFromEntries();
